<template>
  <v-card>
    <v-card-title>
      Úklid
    </v-card-title>
    <cleaning-services-filter
      :orders="items"
      @filter="filterParams = $event"
      />
    <v-card-actions>
      <v-btn small color="primary" :disabled="selectedCleaningService.length===0 || !selectedCleaningService[0].provider" outlined @click="abortOrder">Uvoľniť objednávku</v-btn>
      <v-btn small color="primary" :disabled="selectedCleaningService.length === 0 || selectedCleaningService[0].order.status !== 'in_progress'" outlined @click="stopCleaning">Zastavit úklid</v-btn>
      <v-btn small color="primary" :disabled="selectedCleaningService.length === 0 || selectedCleaningService[0].order.status !== 'accepted'" outlined @click="startCleaning">Začít úklid</v-btn>
      <v-btn small color="primary" :disabled="selectedCleaningService.length === 0" outlined @click="stornoOrder">Zrušit úklid</v-btn>
      <v-btn small color="primary" :disabled="selectedCleaningService.length === 0 || selectedCleaningService[0].order._id !== changedItem.orderId" outlined @click="handleSave">Uložit změny</v-btn>
      <refund-order-dialog
        v-if="selectedCleaningService.length > 0"
        :order-id="selectedCleaningService[0].order._id"
        @refunded="onRefunded"
      >
        <template #default="{ on, attrs }">
          <v-btn
            small
            color="warning"
            outlined
            :disabled="!isOrderRefundable"
            v-on="on"
            class='ml-2'
            v-bind="attrs"
          >
            Vrátit platbu
          </v-btn>
        </template>
      </refund-order-dialog>
      <v-btn v-else small color="warning" outlined disabled>Vrátit platbu</v-btn>
      <refund-cancellation-fee-dialog
        v-if="selectedCleaningService.length > 0 && isCancellationFeeRefundable"
        :order-id="selectedCleaningService[0].order._id"
        @refunded="onCancellationFeeRefunded"
      >
        <template #default="{ on, attrs }">
          <v-btn small color="warning" outlined v-on="on" v-bind="attrs" class="ml-2">
            Vrátit storno poplatek
          </v-btn>
        </template>
      </refund-cancellation-fee-dialog>
      <v-spacer></v-spacer>
      <v-btn small color="primary" outlined to="/app/cleaning-services/create">Vytvořit objednávku</v-btn>
    </v-card-actions>
    <v-data-table class="yzz-table"
                  dense
                  :headers="headers"
                  :items="items"
                  :server-items-length="itemsLength"
                  :options.sync="options"
                  :footer-props="footerProps"
                  multi-sort
                  v-model="selectedCleaningService"
                  single-select
                  :loading="loading"
                  loading-text="Loading... Please wait"
                  show-select
                  mobile-breakpoint="-1"
                  item-key="order._id"
    >
      <template #item.providerName="{ item }">
        <div v-if="item.provider && item.provider.name" style="display: inline-block; width: 140%;">
          <div style="float: left; margin-top: 8px;">{{item.provider.name}}</div>
          <div v-if="item.order.process && item.order.process.abortRequested"  class="ziadost_uvolnenie">
            Žiadosť o uvoľnenie
          </div>
        </div>
        <div v-else class="unassigned" >
          <div v-if="selectedCleaningService.length !== 0 && isSelected(item.order._id) && item.order.status !== 'canceled'" style="">
            <v-combobox
              :text-field-props="{ 'hide-details': 'auto', style: 'font-size: 14px;' }"
              hide-details="auto"
              label="Nepřiřazeno"
              item-text="businessName"
              item-value="_id"
              :items="providers"
              @change="handleProviderChange"
              @update:search-input="(value) => fetchNewProviders(value)"
              outlined
            />
          </div>
          <div v-else>
            Nepřiřazeno
          </div>
        </div>
      </template>
      <template #item.address="{ item }">
        {{ getAddress(item) }}
      </template>
      <template #item.order.date="{ item }">
        <div v-if="isSelected(item.order._id) && (item.order.status === 'active' || item.order.status === 'accepted')" style="width: 200px; padding-top: 5px; padding-bottom: 5px;">
          <datetime-picker
                :text-field-props="{ 'hide-details': 'auto', style: 'font-size: 14px;' }"
                v-model="item.order.date"
                @input="(input) => handleDateTimeSelection(input, item.order._id)"
                :prettyFormat="true"
                :confirmButtonText="'Uložit'"
                :cancelButtonText="'Zrušit'"
                :defaultValueOnCancel="false"
                outlined
                dense
                />
        </div>
        <div v-else>
          {{ formatOrderTime(item) }}
        </div>
      </template>
      <template #item.order.amount="{ item }">
        <div v-if="isSelected(item.order._id) && (item.order.status === 'active' || item.order.status === 'accepted')" style="width: 120px; padding-top: 5px; padding-bottom: 5px;">
          <v-text-field
              hide-details="auto"
              :value="getOrderAmount(item)"
              @input="setOrderAmount(item, $event)"
              type="number"
              min="0"
              step="1"
              label="Cena"
              suffix="Kč"
              @change="handlePriceChange"
              outlined filled dense />
        </div>
        <div v-else>
          {{ formatAmount(item) }}
        </div>
      </template>
      <template #item.order.price.basePrice="{ item }">
        {{ formatBasePrice(item) }}
      </template>
      <template #item.order.createdAt="{ item }">
        {{ formatCreatedAt(item) }}
      </template>
      <template #item.order.additionalServices="{ item }">
        {{ formatAdditionalServices(item) }}
      </template>
      <template #item.customer.name="{ item }">
        {{ getCustomerName(item) }}
      </template>
      <template #item.serviceType.serviceName="{ item }">
        {{ formatServiceType(item) }}
      </template>
      <template #item.order.type="{ item }">
        {{ formatOrderType(item) }}
      </template>
      <template #item.order.objectSize.name.cz="{ item }">
        {{ getConfigurationName(item) }}
      </template>
      <template #item.order.floor="{ item }">
        {{ getFloor(item) }}
      </template>
      <template #item.order.hasDetergents="{ item }">
        {{ getHasDetergents(item) }}
      </template>
      <template #item.order.price.duration="{ item }">
        <div v-if="isSelected(item.order._id) && (item.order.status === 'active' || item.order.status === 'accepted') && getOrderPrice(item)" style="width: 200px; padding-top: 5px; padding-bottom: 5px;">
          <v-text-field
              hide-details="auto"
              :value="getOrderDuration(item)"
              @input="setOrderDuration(item, $event)"
              type="number"
              min="1"
              step="1"
              label="Trvání (hodiny)"
              @change="handleDurationChange"
              outlined filled dense />
        </div>
        <div v-else>
          {{ getOrderDuration(item) }}
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {exportCSVFile, generateRequestParams} from '@/helper/global-helper'
import {formatDatetime} from '@/helper/date-helper'
import CleaningServicesFilter from '@/components/app/cleaning-services/CleaningServicesFilter'
import RefundOrderDialog from '@/components/app/orders/RefundOrderDialog'
import RefundCancellationFeeDialog from '@/components/app/orders/RefundCancellationFeeDialog'

export default {
  name: "CleaningServicesTable",
  components: {
    CleaningServicesFilter,
    RefundOrderDialog,
    RefundCancellationFeeDialog
  },
  data() {
    return {
      headers: [
        // {text:'ID',value:'order._id'},
        {text: 'Poskytovateľ', value: 'providerName', sortable: false},
        {text: 'Zákazník', value: 'customer.name', sortable: false},
        {text: 'Tel. Číslo', value: 'customer.phoneNumber', sortable: false},
        {text: 'Adresa', value: 'address', sortable: false},
        {text: 'Datum a čas', value: 'order.date'},
        {text: 'Cena', value: 'order.amount', sortable: false},
        {text: 'Stav', value: 'order.status'},
        {text: 'Typ objednávky', value: 'order.type'},
        {text: 'Typ služby', value: 'serviceType.serviceName', sortable: false},
        {text: 'Konfigurace', value: 'order.objectSize.name.cz', sortable: false},
        {text: 'Trvání', value: 'order.price.duration', sortable: false},
        {text: 'Základní cena', value: 'order.price.basePrice', sortable: false},
        {text: 'Patro', value: 'order.floor', sortable: false},
        {text: 'Má detergenty', value: 'order.hasDetergents', sortable: false},
        {text: 'Vytvořeno', value: 'order.createdAt'},
        {text: 'Doplňkové služby', value: 'order.additionalServices', sortable: false},
        {text: 'Email', value: 'customer.email', sortable: false},
        {text: 'Akce', value: 'actions', sortable: false},
      ],
      options: {
        itemsPerPage: 15
      },
      footerProps: {
        itemsPerPageOptions: [15, 25, 50]
      },
      data: null,
      search: null,
      selectedCleaningService: [],
      loading: false,
      providersData: null,
      selectedProvider: {},
      changedItem: { orderId: null, providerId: null, selectedDate: null, duration: null, price: null },
      filterParams: null
    }
  },
  mounted() {
    this.getData()
    this.getProviders()
  },
  computed: {
    itemsLength() {
      if (!this.data) return 0
      return this.data.total
    },
    items() {
      if (!this.data) return []
      return this.data.data
    },
    providers() {
      return this.providersData
    },
    isOrderRefundable() {
      if (this.selectedCleaningService.length === 0) return false
      const order = this.selectedCleaningService[0].order
      // Allow refund for orders that are completed or finished
      // The actual eligibility will be checked by the backend via refund-eligibility API
      const refundableStatuses = ['completed', 'finished']
      return refundableStatuses.includes(order.status)
    },
    isCancellationFeeRefundable() {
      if (this.selectedCleaningService.length === 0) return false
      // Only cancelled orders can have a storno fee to refund;
      // the dialog confirms via the eligibility endpoint.
      return this.selectedCleaningService[0].order.status === 'canceled'
    }
  },
  methods: {
    getData() {
      let params = generateRequestParams(
          this.options.itemsPerPage * (this.options.page - 1),
              this.options.itemsPerPage,
              null,
              this.options.sortDesc[this.options.sortBy.indexOf("order.date")] ? "asc" : "desc",
              "date"
      )

      if (this.filterParams && this.filterParams.filter) {
        if (this.filterParams.filter.id) {
          params.append(`id`, String(this.filterParams.filter.id));
        }
        if (this.filterParams.filter.parentId) {
          params.append(`parentId`, String(this.filterParams.filter.parentId));
        }
        if (this.filterParams.filter.customer) {
          params.append(`customer`, String(this.filterParams.filter.customer));
        }
        if (this.filterParams.filter.provider) {
          params.append(`provider`, String(this.filterParams.filter.provider));
        }
        if (this.filterParams.filter.address) {
          params.append(`address`, String(this.filterParams.filter.address));
        }
        if (this.filterParams.filter.dateAndTime) {
          if (this.filterParams.filter.dateAndTime.from) {
            params.append(
              `from`,
              String(this.filterParams.filter.dateAndTime.from)
            );
          }
          if (this.filterParams.filter.dateAndTime.to) {
            params.append(
              `to`,
              String(this.filterParams.filter.dateAndTime.to)
            );
          }
        }
        if (this.filterParams.filter.status) {
          this.filterParams.filter.status.forEach((status) => {
            params.append("status", status);
          });
        }
        if (this.filterParams.filter.orderType) {
          this.filterParams.filter.orderType.forEach((orderType) => {
            params.append("orderType", orderType);
          });
        }
      }

      this.axios.get('/v1/cleaning-orders', {
        params
      })
          .then(({data}) => {
            this.data = data
          })
    },
    async getProviders(query = null) {
      let params = {
        skip: 0,
        limit: 50,
      };

      if (query) {
        params[`filter[businessName][$regex]`] = query;
        params[`filter[businessName][$options]`] = 'i'; // Case-insensitive search
      }

      try {
        const response = await this.axios.get('/v1/users/providers', {
          params: params,
        });

        this.providersData = response.data.data;
      } catch (error) {
        // Handle any errors here
        console.error('Error fetching providers:', error);
        throw error;
      }
    },
    openCleaningService({_id}) {
      this.$router.push('/app/cleaning-services/' + _id)
    },
    formatCreatedAt({order}) {
      return formatDatetime(order.createdAt)
    },
    formatOrderTime({order}) {
      return formatDatetime(order.date)
    },
    formatAmount({order}) {
      return order.amount + " Kč"
    },
    formatBasePrice({order}) {
      const price = order.price || order.serviceData?.price
      return (price?.basePrice || '-') + " Kč"
    },
    formatStatus({status}) {
      return this.$store.getters['types/getCleaningServiceStatusByCode'](status).name
    },
    formatAdditionalServices({order}){
      const additionalServices = order.additionalServices || order.serviceData?.additionalServices
      return additionalServices ? additionalServices.map((s) => s.name).join(', ') : ""
    },
    formatServiceType({serviceType}) {
      const translations = {
        'cleaning': 'Úklid',
        'general_cleaning': 'Generální úklid',
        'carpet_beating': 'Tepování',
      }
      const key = serviceType?.key || 'cleaning'
      return translations[key] || serviceType?.serviceName || 'Úklid'
    },
    formatOrderType({order}) {
      const translations = {
        'standard_order': 'Jednorázová',
        'repeated_order_base': 'Opakovaná (základ)',
        'repeated_order': 'Opakovaná',
      }
      const type = order?.type || order?.serviceData?.type
      return translations[type] || type || '-'
    },
    getCustomerName({customer}) {
      return customer?.name || '-'
    },
    // Helper methods for handling both CleaningOrder and Order formats
    getOrderPrice({order}) {
      return order?.price || order?.serviceData?.price
    },
    getOrderDuration({order}) {
      const price = order?.price || order?.serviceData?.price
      return price?.duration || '-'
    },
    setOrderDuration(item, value) {
      const order = item.order
      if (order.price) {
        order.price.duration = Number(value)
      } else if (order.serviceData?.price) {
        order.serviceData.price.duration = Number(value)
      }
    },
    getOrderAmount({order}) {
      return order.amount || 0
    },
    setOrderAmount(item, value) {
      item.order.amount = Number(value)
    },
    getConfigurationName({order, serviceType}) {
      // Get configuration key from order (CleaningOrder or Order)
      const configKey = order?.objectSize?.key || order?.serviceData?.objectSizeKey

      // Always look up configuration description from serviceType.estimateConfiguration
      if (configKey && serviceType?.estimateConfiguration) {
        const config = serviceType.estimateConfiguration.find(c => c.key === configKey)
        if (config?.description) {
          return config.description
        }
      }

      return '-'
    },
    getFloor({order}) {
      return order?.floor ?? order?.serviceData?.floor ?? '-'
    },
    getHasDetergents({order}) {
      const hasDetergents = order?.hasDetergents ?? order?.serviceData?.hasDetergents
      if (hasDetergents === undefined || hasDetergents === null) return '-'
      return hasDetergents ? 'Ano' : 'Ne'
    },
    deleteCleaningService() {
      const cleaningService = this.selectedCleaningService[0].id
      this.axios.delete('/api/admin/cleaning-service/' + cleaningService)
          .then(({data}) => {
            this.selectedCleaningService = []
            if (this.data)
              this.data.content = this.data.content.filter(item => item.id !== cleaningService)
          })
    },
    exportCsv(){
      exportCSVFile(this.headers, this.items, 'cleaning-services')
    },
    getAddress({order}){
      return order?.address?.value || order?.serviceData?.address?.value || order?.serviceData?.locationFrom || '-'
    },
    abortOrder(){
      const orderId = this.selectedCleaningService[0].order._id
      this.axios.put('/v1/cleaning-orders/' + orderId + '/abort').then(()=>{
        this.selectedCleaningService[0].provider = null
        this.$store.commit('addAlert', {
          type: 'success',
          message: "Úspěšně"
        })
      })
    },
    stopCleaning(){
      const orderId = this.selectedCleaningService[0].order._id
      this.axios.put('/v1/cleaning-orders/' + orderId + '/force-complete').then(({data})=>{
        this.selectedCleaningService[0].order.status = data.status
        this.$store.commit('addAlert', {
          type: 'success',
          message: "Úspěšně"
        })
      })
    },
    handleDateTimeSelection(selectedValue, id) {
      if (!selectedValue) return

      if (this.selectedCleaningService[0].order._id !== this.changedItem.orderId) {
        this.changedItem.providerId = null
      }

      this.changedItem.selectedDate = selectedValue
      this.changedItem.orderId = id
    },
    handleProviderChange(value) {
      if (this.selectedCleaningService[0].order._id !== this.changedItem.orderId) {
        this.changedItem.selectedDate = null
      }

      this.changedItem.orderId = this.selectedCleaningService[0].order._id
      this.changedItem.providerId = value._id
    },
    handleDurationChange(value) {
      if (this.selectedCleaningService[0].order._id !== this.changedItem.orderId) {
        this.changedItem.selectedDate = null
      }

      this.changedItem.orderId = this.selectedCleaningService[0].order._id
      const order = this.selectedCleaningService[0].order
      const price = order?.price || order?.serviceData?.price
      this.changedItem.duration = price?.duration
    },
    handlePriceChange(value) {
      if (this.selectedCleaningService[0].order._id !== this.changedItem.orderId) {
        this.changedItem.selectedDate = null
      }

      this.changedItem.orderId = this.selectedCleaningService[0].order._id
      this.changedItem.price = this.selectedCleaningService[0].order.amount
    },
    stornoOrder(){
      const orderId = this.selectedCleaningService[0].order._id
      this.axios.put('/v1/cleaning-orders/' + orderId + '/storno').then(({ data }) => {
        this.selectedCleaningService[0].order.status = data.status
        this.$store.commit('addAlert', {
          type: 'success',
          message: "Úspěšně"
        })
      })
    },
    isSelected(orderId) {
      if (this.selectedCleaningService.length === 0)
        return false
      return orderId === this.selectedCleaningService[0]?.order._id
    },
    handleSave() {
      const orderId = this.selectedCleaningService[0].order._id
      const providerId = this.changedItem.providerId
      const selectedDate = this.changedItem.selectedDate
      const duration = this.changedItem.duration
      const price = this.changedItem.price

      const promises = []

      if (typeof providerId === 'string' && typeof orderId === 'string') {
        const promise = this.axios.post('/v1/cleaning-orders/' + orderId + '/assign-provider', {
          providerId: providerId
        }).then(({ data }) => {
          this.selectedCleaningService[0].order.providerId = data.providerId
          this.$store.commit('addAlert', {
            type: 'success',
            message: "Úspěšně"
          })
        })
        promises.push(promise)
      }

      if (selectedDate) {
        const promise = this.axios.post('/v1/cleaning-orders/update-time/' + orderId, {
          date: selectedDate
        }).then(({ data }) => {
          this.$store.commit('addAlert', {
            type: 'success',
            message: "Úspěšně"
          })
        })
        promises.push(promise)
      }

      if (duration) {
        const promise = this.axios.post(`/v1/cleaning-orders/${orderId}/update-duration`, {
          duration: duration
        }).then(({ data }) => {
          this.$store.commit('addAlert', {
            type: 'success',
            message: "Úspěšně"
          })
        })
        promises.push(promise)
      }

      if (price) {
        const promise = this.axios.post(`/v1/cleaning-orders/${orderId}/update-price`, {
          price: price
        }).then(({ data }) => {
          this.$store.commit('addAlert', {
            type: 'success',
            message: "Úspěšně"
          })
        })
        promises.push(promise)
      }

      Promise.all(promises).then(() => {
        location.reload()
      })
    },
    fetchNewProviders(value) {
      this.getProviders(value)
    },
    startCleaning(){
      const orderId = this.selectedCleaningService[0].order._id
      this.axios.get('/v1/cleaning-orders/' + orderId + '/force-start').then(({data})=>{
        this.selectedCleaningService[0].order.status = data.status
        this.$store.commit('addAlert', {
          type: 'success',
          message: "Úspěšně"
        })
      })
    },
    onRefunded(data) {
      this.$store.commit('addAlert', {
        type: 'success',
        message: `Platba ${data.amount} Kč byla úspěšně vrácena`
      })
      this.getData()
    },
    onCancellationFeeRefunded() {
      this.getData()
    },
  },
  watch: {
    filterParams: {
      handler() {
        // Reset to first page when filter changes
        this.options.page = 1;
        this.getData();
      },
      deep: true,
    },
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    }
  }
}
</script>

<style scoped>
.unassigned{
  color: orange;
  width: 150px;
}
.ziadost_uvolnenie{
  background-color: red;
  color: #fff;
  height: 25px;
  padding: 5px;
  margin-top: 5px;
  margin-right: 60px;
  border-radius: 7px;
  text-align: center;
  float: right;
  font-size: 11px;
}
</style>
